const productRecommendationsWrapper = document.querySelector(
  ".product__recommendations--wrapper"
);
const productRecommendationsList = document.querySelector(
  ".product__recommendations--list"
);

const productRecommendationsWrapperMobile = document.querySelector(
  ".product__recommendations--wrapper--mobile"
);

document.addEventListener("cart:open", () => {
  startClerk();
  setTimeout(function () {
    productRecommendationsWrapper.classList.add(
      "product__recommendations--wrapper--active"
    );
    //productRecommendationsWrapperMobile.classList.add('product__recommendations--wrapper--active--mobile')
  }, 700);
});

document.addEventListener("cart:close", () => {
  productRecommendationsWrapper.classList.remove(
    "product__recommendations--wrapper--active"
  );
  //productRecommendationsWrapperMobile.classList.remove('product__recommendations--wrapper--active--mobile')
});

function startClerk() {
  Clerk(
    "call",
    "recommendations/visitor/complementary",
    {
      key: "GlsOYug1GjFra2T1ifQ4BImpXxcXC7R9",
      limit: 10,
      labels: ["Cart Upsell"],
    },
    function (response) {
      getClerkProducts(response.result);
    },
    function (response) {
      console.error(response);
    }
  );
}

function getClerkProducts(arr) {
  Clerk(
    "call",
    "product/attributes",
    {
      key: "GlsOYug1GjFra2T1ifQ4BImpXxcXC7R9",
      products: arr,
    },
    function (response) {
      const productRecommendationsListMobile = document.querySelector(
        ".product__recommendations--list--mobile"
      );
      productRecommendationsList.innerHTML = "";
      productRecommendationsListMobile.innerHTML = "";
      response.forEach((element) => {
        productRecommendationsList.insertAdjacentHTML(
          "beforeend",
          buildClerkProductCard(element)
        );
        productRecommendationsListMobile.insertAdjacentHTML(
          "beforeend",
          buildClerkProductCard(element)
        );
      });
      Clerk("click", "*[data-clerk-product-id]");
    },
    function (response) {
      console.error(response);
    }
  );
}

function buildClerkProductCard(product) {
  const { id, image, name, list_price, price, url } = product;

  const element = `
    <a href="${url}" data-clerk-product-id="${id}">
        <div class="recommended__product--wrapper">

            <div class="recommended__product--image">
                <img src="${image}">
            </div>

            <div class="recommended__product--info">
                <p class="recommended__product--title">${name}</p>
                ${
                  price < list_price
                    ? `<p class="recommended__product--onSale">${Shopify.formatMoney(
                        list_price * 100,
                        theme.moneyFormat
                      )}</p>`
                    : ""
                }
                <p class="recommended__product--price">${Shopify.formatMoney(
                  price * 100,
                  theme.moneyFormat
                )}</p>
                
            </div>

        </div>
    </a>
    `;

  return element;
}

var Shopify = Shopify || {};
// ---------------------------------------------------------------------------
// Money format handler
// ---------------------------------------------------------------------------
Shopify.money_format = "${{amount}}";
Shopify.formatMoney = function (cents, format) {
  if (typeof cents == "string") {
    cents = cents.replace(".", "");
  }
  var value = "";
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  var formatString = format || this.money_format;

  function defaultOption(opt, def) {
    return typeof opt == "undefined" ? def : opt;
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ",");
    decimal = defaultOption(decimal, ".");

    if (isNaN(number) || number == null) {
      return 0;
    }

    number = (number / 100.0).toFixed(precision);

    var parts = number.split("."),
      dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + thousands),
      cents = parts[1] ? decimal + parts[1] : "";

    return dollars + cents;
  }

  switch (formatString.match(placeholderRegex)[1]) {
    case "amount":
      value = formatWithDelimiters(cents, 2);
      break;
    case "amount_no_decimals":
      value = formatWithDelimiters(cents, 0);
      break;
    case "amount_with_comma_separator":
      value = formatWithDelimiters(cents, 2, ".", ",");
      break;
    case "amount_no_decimals_with_comma_separator":
      value = formatWithDelimiters(cents, 0, ".", ",");
      break;
  }

  return formatString.replace(placeholderRegex, value);
};
